import {
  SIGNOUT_FAILED,
  SIGNOUT_SUCCESS,
  FETCH_APPRAISAL_YEAR_OPTIONS_FAILED,
  FETCH_APPRAISAL_YEAR_OPTIONS_START,
  FETCH_APPRAISAL_YEAR_OPTIONS_SUCCESS,
  FETCH_FORM_OPTIONS_FAILED,
  FETCH_FORM_OPTIONS_START,
  FETCH_FORM_OPTIONS_SUCCESS,
  FETCH_FEEDBACK_EMP_START,
  FETCH_FEEDBACK_EMP_SUCCESS,
  FETCH_FEEDBACK_EMP_FAILED,
  FETCH_FEEDBACK_STRUCTURE_START,
  FETCH_FEEDBACK_STRUCTURE_SUCCESS,
  FETCH_FEEDBACK_STRUCTURE_FAILED,
  FETCH_FEEDBACK_HISTORY_START,
  FETCH_FEEDBACK_HISTORY_SUCCESS,
  FETCH_FEEDBACK_HISTORY_FAILED,
  FETCH_SELF_POSITION_START,
  FETCH_SELF_POSITION_SUCCESS,
  FETCH_SELF_POSITION_FAILED,
  POST_FEEDBACK_HISTORY_START,
  POST_FEEDBACK_HISTORY_SUCCESS,
  POST_FEEDBACK_HISTORY_FAILED,
  SET_FEEDBACK_READ_STATE,
  FETCH_EMPLOYEE_OPTIONS_START,
  FETCH_EMPLOYEE_OPTIONS_SUCCESS,
  FETCH_EMPLOYEE_OPTIONS_FAILED,
  FETCH_EMPLOYEE_POSITIONS_SUCCESS,
  FETCH_EMPLOYEE_POSITIONS_START,
  FETCH_EMPLOYEE_POSITIONS_FAILED
} from '../actions/actionTypes'

const initialState = {
  currentFilter: null,
  currentUser: null,
  currentHistoryId: null,
  feedbackStructures: [],
  feedbackEmps: [],
  feedbackHistory: [],
  loadingStates: [],
  records: [],
  years: [],
  forms: [],
  positions: []
}

const fetchFormOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'form_id'] }
}

const fetchFormOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    forms: data,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id')
  }
}

const fetchFormOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'form_id') }
}

const fetchAppraisalYearOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'appraisal_year'] }
}

const fetchAppraisalYearOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    years: data,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_year')
  }
}

const fetchAppraisalYearOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'appraisal_year') }
}

const fetchSelfPositionStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'position_id'] }
}

const fetchSelfPositionSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    positions: data
  }
}

const fetchSelfPositionFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'position_id') }
}

const fetchEmpOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'emp_id'] }
}

const fetchEmpOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    emps: data
  }
}

const fetchEmpOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'emp_id') }
}

const fetchFeedbackEmpStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'feedbackEmp']
  }
}

const fetchFeedbackEmpSuccess = (state, { data, filter }) => {
  return {
    ...state,
    currentFilter: filter,
    feedbackEmps: data,
    loadingStates: state.loadingStates.filter(item => item !== 'feedbackEmp'),
    feedbackStructures: []
  }
}

const fetchFeedbackEmpFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'feedbackEmp')
  }
}

const fetchFeedbackStructureStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'feedbackStructure']
  }
}

const fetchFeedbackStructureSuccess = (state, { data, user }) => {
  return {
    ...state,
    feedbackStructures: data,
    currentUser: user,
    loadingStates: state.loadingStates.filter(item => item !== 'feedbackStructure')
  }
}

const fetchFeedbackStructureFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'feedbackStructure')
  }
}

const fetchFeedbackHistoryStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'feedbackHistory']
  }
}

const fetchFeedbackHistorySuccess = (state, { chatHistory, resultId }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'feedbackHistory'),
    feedbackHistory: chatHistory,
    currentHistoryId: resultId
  }
}

const fetchFeedbackHistoryFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'feedbackHistory'),
    feedbackHistory: []
  }
}

const postFeedbackHistoryStart = (state, { chatHistory }) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'postFeedback'],
    feedbackHistory: chatHistory
  }
}

const postFeedbackHistorySuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'postFeedback')
  }
}

const postFeedbackHistoryFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'postFeedback') }
}

const setFeedbackReadState = (state, { resultItemId }) => {
  return {
    ...state,
    feedbackStructures: state.feedbackStructures.map(st => {
      const updatedItems = st.items.map(item =>
        resultItemId === item.result_item_id
          ? {
              ...item,
              is_unread: false
            }
          : item
      )
      return { ...st, items: updatedItems }
    })
  }
}

const reducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCH_FORM_OPTIONS_START:
      return fetchFormOptionsStart(state, payload)
    case FETCH_FORM_OPTIONS_SUCCESS:
      return fetchFormOptionsSuccess(state, payload)
    case FETCH_FORM_OPTIONS_FAILED:
      return fetchFormOptionsFailed(state, payload)

    case FETCH_APPRAISAL_YEAR_OPTIONS_START:
      return fetchAppraisalYearOptionsStart(state, payload)
    case FETCH_APPRAISAL_YEAR_OPTIONS_SUCCESS:
      return fetchAppraisalYearOptionsSuccess(state, payload)
    case FETCH_APPRAISAL_YEAR_OPTIONS_FAILED:
      return fetchAppraisalYearOptionsFailed(state, payload)

    case FETCH_SELF_POSITION_START:
    case FETCH_EMPLOYEE_POSITIONS_START:
      return fetchSelfPositionStart(state, payload)
    case FETCH_SELF_POSITION_SUCCESS:
    case FETCH_EMPLOYEE_POSITIONS_SUCCESS:
      return fetchSelfPositionSuccess(state, payload)
    case FETCH_SELF_POSITION_FAILED:
    case FETCH_EMPLOYEE_POSITIONS_FAILED:
      return fetchSelfPositionFailed(state, payload)

    case FETCH_FEEDBACK_EMP_START:
      return fetchFeedbackEmpStart(state, payload)
    case FETCH_FEEDBACK_EMP_SUCCESS:
      return fetchFeedbackEmpSuccess(state, payload)
    case FETCH_FEEDBACK_EMP_FAILED:
      return fetchFeedbackEmpFailed(state, payload)

    case FETCH_FEEDBACK_STRUCTURE_START:
      return fetchFeedbackStructureStart(state, payload)
    case FETCH_FEEDBACK_STRUCTURE_SUCCESS:
      return fetchFeedbackStructureSuccess(state, payload)
    case FETCH_FEEDBACK_STRUCTURE_FAILED:
      return fetchFeedbackStructureFailed(state, payload)

    case FETCH_FEEDBACK_HISTORY_START:
      return fetchFeedbackHistoryStart(state, payload)
    case FETCH_FEEDBACK_HISTORY_SUCCESS:
      return fetchFeedbackHistorySuccess(state, payload)
    case FETCH_FEEDBACK_HISTORY_FAILED:
      return fetchFeedbackHistoryFailed(state, payload)

    case POST_FEEDBACK_HISTORY_START:
      return postFeedbackHistoryStart(state, payload)
    case POST_FEEDBACK_HISTORY_SUCCESS:
      return postFeedbackHistorySuccess(state, payload)
    case POST_FEEDBACK_HISTORY_FAILED:
      return postFeedbackHistoryFailed(state, payload)

    case FETCH_EMPLOYEE_OPTIONS_START:
      return fetchEmpOptionsStart(state, payload)
    case FETCH_EMPLOYEE_OPTIONS_SUCCESS:
      return fetchEmpOptionsSuccess(state, payload)
    case FETCH_EMPLOYEE_OPTIONS_FAILED:
      return fetchEmpOptionsFailed(state, payload)

    case SET_FEEDBACK_READ_STATE:
      return setFeedbackReadState(state, payload)

    case SIGNOUT_SUCCESS:
    case SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
